import { assocPath, mergeDeepRight } from 'ramda'
import thunk from 'redux-thunk'
import { createReducer } from 'reduxsauce'

import FetchingMiddleware from '../services/FetchingMiddleware'
import type { UserStateType } from '../types/UserStateType'
import { createTypedActions } from './redux.utils'

/* ------------- Types and Action Creators ------------- */

// ENUMS
export const USER_TYPE = {
  CLIENT: 0,
  THERAPIST: 1,
}

const ACTIONS = {
  onChangeUserValue: ['path', 'value'],
  onMergeUserValue: ['value'],
  loginRequest: ['email', 'password', 'therapistId', 'diagnosis', 'redirectUrl', 'companyEmployee'],
  loginRequestFacebook: ['code', 'therapistId', 'diagnosis', 'redirectUrl', 'doNotCreateNewUser', 'companyEmployee'],
  loginRequestGoogle: ['idToken', 'therapistId', 'diagnosis', 'redirectUrl', 'doNotCreateNewUser', 'companyEmployee'],
  updateUserDataRequest: ['data'],
  getUserDataRequest: ['therapistId', 'withoutRedirect', 'gtm', 'diagnosisData', 'redirectUrl', 'currentPathname'],
  getAllEventsRequest: ['userType', 'userId'],
  getTherapistSpecializationsRequest: ['userType'],
}

const { Types, Creators } = createTypedActions<keyof typeof ACTIONS>(ACTIONS)

// ======================================================
// Middleware Configuration
// ======================================================
const middleware = [thunk]

middleware.push(FetchingMiddleware as any)

const UserActions = Creators
export const UserTypes = Types
export default UserActions

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  email: '',
  id: null,
  firstName: '',
  lastName: '',
  phone: '',
  sendMessageNotifications: false,
  gdpr: false,
  type: null,
  videoChatCredentials: {},
  note: '',
  fullName: '',
  street: '',
  houseNumber: '',
  registrationNumber: '',
  city: '',
  zip: '',
  chat: {
    downloadFileIndex: {},
  },
  cancelModalVisible: false,
  visitedTherapistIds: [],
}

/* ------------- Reducers ------------- */

export const onChangeUserValueR = (
  state: UserStateType,
  { path, value }: { path: string; value: object | string | boolean | number },
): UserStateType => {
  return assocPath(path.split('.'), value, state)
}

export const onMergeUserValueR = (
  state: UserStateType,
  { value }: { value: object | boolean | number | string },
): UserStateType => mergeDeepRight(state, value)

const removePasswordState = (state) => {
  delete state.password
  return state
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ON_CHANGE_USER_VALUE]: onChangeUserValueR,
  [Types.ON_MERGE_USER_VALUE]: onMergeUserValueR,
  [Types.LOGIN_REQUEST]: (state) => removePasswordState(state),
  [Types.LOGIN_REQUEST_FACEBOOK]: (state) => state,
  [Types.LOGIN_REQUEST_GOOGLE]: (state) => state,
  [Types.UPDATE_USER_DATA_REQUEST]: (state) => state,
  [Types.GET_USER_DATA_REQUEST]: (state) => state,
  [Types.GET_ALL_EVENTS_REQUEST]: (state) => state,
  // this can get removed once old diagnosis is removed
  [Types.GET_THERAPIST_SPECIALIZATIONS_REQUEST]: (state) => state,
} as any)
